<template>
  <div v-if="data">
    <div class="user-heading">
      <img :src="data.targetInfo.userInfo.avatarUrl" class="user-avatar" />
      <div class="user-name">
        {{data.targetInfo.userInfo.nickname}}
        <span
          class="text-grey"
        >({{data.targetInfo.targetName}})</span>
      </div>
    </div>

    <div class="card">
      <div class="card-title">{{data.targetInfo.targetName}}</div>
      <div class="card-body">
        <div class="grey">总天数</div>
        <div>
          <span class="bold large">{{data.targetInfo.dayNumber}}</span>天
        </div>

        <div style="display:flex;padding:10px 0 0;">
          <div style="flex:1;">
            <div class="grey">打卡天数</div>
            <div>
              <span class="bold mid">{{data.targetInfo.timingDayCount}}</span>天
            </div>
          </div>
          <div style="flex:1;">
            <div class="grey">打卡时长</div>
            <div>
              <span class="bold mid">{{parseInt(data.targetInfo.timingTotalSeconds / 3600)}}</span>小时
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" style="margin-bottom: 60px;">
      <div class="card-body">
        <div class="exp-title">康复经历</div>
        <div v-for="(row, index) of data.list" v-bind:key="index">
          <div class="exp-title">{{row.expDate}}</div>
          <div class="exp-content">
            <div class="exp-text" v-html="nl2br(row.content)"></div>
            <div class="exp-img" v-if="row.mediaList">
              <img :src="row.mediaList[0]['250x200.75.jpg']" />
            </div>
          </div>
        </div>
        <div class="footer-mask" v-if="hasMore" @click="getMore">{{loading ? '加载中...' : '查看更多'}}</div>
        <div class="footer-mask" v-else>已加载全部</div>
      </div>
    </div>

    <div class="card footer">
      <a
        class="footer-btn"
        href="https://sj.qq.com/myapp/detail.htm?apkName=cn.shareyourhealth.egghealth"
      >下载蛋壳健康APP, 查看TA的完整经历 &gt;</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      data: null,
      page: 1,
      loading: true,
      hasMore: true
    };
  },
  created() {
    this.getFeeds();
  },
  methods: {
    nl2br(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    async getFeeds() {
      this.loading = true;
      let res = await this.axios.get(
        `/api/v1/feeds/exp/detail?pageNo=${this.page}&pageSize=10&targetId=${this.$route.query.targetId}`
      );

      if (res.data.list.length > 0) {
        if (this.page === 1) {
          this.data = res.data;
        } else {
          this.data.list = this.data.list.concat(res.data.list);
        }
      } else {
        this.hasMore = false;
      }
      this.loading = false;
    },
    getMore() {
      this.page = this.page + 1;
      this.getFeeds();
    }
  }
};
</script>
<style lang="less">
.user-heading {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px 15px;

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }
  .user-name {
    font-size: 16px;
    font-weight: bold;
    flex: 1;
    text-align: left;
  }
  .text-grey {
    color: #999;
    font-size: 14px;
    font-weight: normal;
  }
}

.card {
  border-radius: 6px;
  background: #fff;
  margin: 15px 10px;
  font-size: 14px;
  line-height: 1.5;
  .card-title {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    line-height: 3;
    color: #fff;
    background-color: #00bf80;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .card-body {
    padding: 10px;
  }

  .grey {
    color: #666;
  }
}

.bold {
  font-weight: bold;
}

.large {
  font-size: 32px;
  margin-right: 3px;
}

.mid {
  font-size: 24px;
  margin-right: 2px;
}

.exp-title {
  font-weight: bold;
  line-height: 2;
}

.exp-content {
  display: flex;
  padding-bottom: 10px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e5e5e5;

  .exp-img {
    width: 100px;
    margin-left: 10px;
    img {
      width: 100%;
      max-width: 100%;
      height: auto;
      display: block;
    }
  }

  .exp-text {
    flex: 1;
  }
}

.footer-btn {
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 0;
  display: block;
  text-decoration: none;
  color: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
  border-radius: 20px;
  background: rgba(0, 191, 128, 0.9);
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  margin: 0 10px;
  padding: 20px 0;
}

.footer-mask {
  height: 80px;
  text-align: center;
}
</style>
